import classNames from 'classnames'
import { IconSizes } from 'types/general'
import { StatusType } from 'types/status'

import IconRender from '../IconRender'
import IconButtonStatus from './IconButtonStatus'

interface IconButtonProps {
  icon: string
  size?: IconSizes
  color?: string
  hoverColor?: string
  iconStatus?: StatusType
  iconStatusCustomClass?: string
  className?: string
  containerClassName?: string
  handleClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}
const IconButton = ({
  icon,
  size = IconSizes.MD,
  color,
  hoverColor,
  iconStatus,
  iconStatusCustomClass,
  className,
  containerClassName,
  handleClick,
}: IconButtonProps) => {
  return (
    <div
      className={classNames(
        containerClassName ? containerClassName : 'relative flex'
      )}
    >
      <IconButtonStatus
        status={iconStatus}
        statusCustomClass={iconStatusCustomClass}
      />
      <button
        type="button"
        onClick={e => handleClick(e)}
        className="rounded-full outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-imovPrimary"
      >
        <IconRender
          icon={icon}
          size={size}
          color={color}
          hoverColor={hoverColor}
          className={classNames(className)}
        />
      </button>
    </div>
  )
}

export default IconButton
